module.exports = __webpack_public_path__ + "static/img/hb.e0682b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hb.jpg
// module id = 4KL6
// module chunks = 1